
export function formatErrorResponse(response) {
  return {
    ok: false,
    error: response.data && response.data.message ? response.data.message : response.problem,
  };
}

export function formatAuthResponse(response) {
  const { data: userData } = response;
  const {
    access_token: accessToken,
    available_menus: availableMenus,
    ...rest
  } = userData;
  return {
    ...rest,
    availableMenus,
    accessToken: {
      accessToken: accessToken.access_token,
      tokenType: accessToken.token_type,
      client: accessToken.client,
      expiry: accessToken.expiry,
      uid: accessToken.uid,
    },
  };
}



// WEBPACK FOOTER //
// ./src/utils/response.js